import { render, staticRenderFns } from "./home-title.vue?vue&type=template&id=0f2baf0c&"
import script from "./home-title.vue?vue&type=script&lang=js&"
export * from "./home-title.vue?vue&type=script&lang=js&"
import style0 from "./home-title.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2baf0c')) {
      api.createRecord('0f2baf0c', component.options)
    } else {
      api.reload('0f2baf0c', component.options)
    }
    module.hot.accept("./home-title.vue?vue&type=template&id=0f2baf0c&", function () {
      api.rerender('0f2baf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/home-title.vue"
export default component.exports